"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.customEngineAgentTemplates = void 0;
const templateNames_1 = require("../templateNames");
exports.customEngineAgentTemplates = [
    {
        id: "custom-copilot-basic-ts",
        name: templateNames_1.TemplateNames.CustomCopilotBasic,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-basic-js",
        name: templateNames_1.TemplateNames.CustomCopilotBasic,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-basic-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotBasic,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-basic-python",
        name: templateNames_1.TemplateNames.CustomCopilotBasic,
        language: "python",
        description: "",
    },
    {
        id: "custom-copilot-rag-customize-ts",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomize,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-rag-customize-js",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomize,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-rag-customize-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomize,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-rag-customize-python",
        name: templateNames_1.TemplateNames.CustomCopilotRagCustomize,
        language: "python",
        description: "",
    },
    {
        id: "custom-copilot-rag-azure-ai-search-ts",
        name: templateNames_1.TemplateNames.CustomCopilotRagAzureAISearch,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-rag-azure-ai-search-js",
        name: templateNames_1.TemplateNames.CustomCopilotRagAzureAISearch,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-rag-azure-ai-search-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotRagAzureAISearch,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-rag-azure-ai-search-python",
        name: templateNames_1.TemplateNames.CustomCopilotRagAzureAISearch,
        language: "python",
        description: "",
    },
    {
        id: "custom-copilot-rag-microsoft365-ts",
        name: templateNames_1.TemplateNames.CustomCopilotRagMicrosoft365,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-rag-microsoft365-js",
        name: templateNames_1.TemplateNames.CustomCopilotRagMicrosoft365,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-rag-microsoft365-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotRagMicrosoft365,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-assistant-new-ts",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantNew,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-assistant-new-js",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantNew,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-assistant-new-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantNew,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-assistant-new-python",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantNew,
        language: "python",
        description: "",
    },
    {
        id: "custom-copilot-assistant-assistants-api-ts",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantAssistantsApi,
        language: "typescript",
        description: "",
    },
    {
        id: "custom-copilot-assistant-assistants-api-js",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantAssistantsApi,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-assistant-assistants-api-csharp",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantAssistantsApi,
        language: "csharp",
        description: "",
    },
    {
        id: "custom-copilot-assistant-assistants-api-python",
        name: templateNames_1.TemplateNames.CustomCopilotAssistantAssistantsApi,
        language: "python",
        description: "",
    },
];
//# sourceMappingURL=cea.js.map